// src/lib/dexie/db.ts
import Dexie, { Table } from "dexie";

export interface CachedMedia {
  messageId: number;
  mediaType: "image" | "video" | "audio" | "file";
  // ❌ DO NOT persist blobUrl strings
  blob?: Blob;            // ✅ store the actual Blob
  mimeType?: string;
  updatedAt: number;
}

class MediaCacheDB extends Dexie {
  cachedMedia!: Table<CachedMedia, number>;

  constructor() {
    super("MediaCacheDB");

    // v1 had: cachedMedia: "messageId, mediaType, updatedAt"
    // v2: add 'blob' and 'mimeType' fields (Dexie stores Blob just fine)
    this.version(2).stores({
      cachedMedia: "messageId, mediaType, updatedAt",
    })
    .upgrade(async (tx) => {
      // optional: clean any legacy rows that had only blobUrl
      const all = await tx.table("cachedMedia").toArray();
      for (const row of all) {
        // if legacy shape existed, you can purge or keep
        // here: purge entries that don't have Blob
        if (!("blob" in row) || !row.blob) {
          await tx.table("cachedMedia").delete(row.messageId);
        }
      }
    });
  }
}

export const mediaCacheDB = new MediaCacheDB();
